import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

// Lightweight PWA install prompt (Chrome/Android + Edge). iOS shows Add to Home instructions.
export default function InstallPWA() {
  const [evt, setEvt] = useState(null);
  const [dismissed, setDismissed] = useState(() => localStorage.getItem("em_pwa_dismissed") === "1");
  const [iosHint, setIosHint] = useState(false);

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setEvt(e); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const isStandalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (isIOS && !isStandalone && !dismissed) setIosHint(true);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, [dismissed]);

  const dismiss = () => {
    localStorage.setItem("em_pwa_dismissed", "1");
    setDismissed(true); setEvt(null); setIosHint(false);
  };

  if (dismissed || (!evt && !iosHint)) return null;

  const install = async () => {
    if (!evt) return;
    evt.prompt();
    const { outcome } = await evt.userChoice;
    if (outcome === "accepted") dismiss();
  };

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 mx-auto max-w-sm rounded-lg border border-white/10 bg-[#0d0d0d]/95 p-4 shadow-2xl backdrop-blur-xl sm:left-auto sm:right-6" data-testid="install-pwa">
      <div className="flex items-start gap-3">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-brand-gradient text-white"><Download size={18} /></span>
        <div className="min-w-0 flex-1">
          <p className="font-head text-sm font-medium uppercase text-white">Installer l'app</p>
          {iosHint ? (
            <p className="mt-1 text-xs text-white/60">Sur iPhone : appuyez sur <span className="text-white">Partager</span> puis <span className="text-white">Sur l'écran d'accueil</span>.</p>
          ) : (
            <p className="mt-1 text-xs text-white/60">Accédez à Event's Multitechnique en un tap depuis votre écran d'accueil.</p>
          )}
          {!iosHint && (
            <button onClick={install} className="mt-3 rounded-full bg-brand-gradient px-4 py-2 text-xs font-semibold text-white" data-testid="install-pwa-btn">Installer</button>
          )}
        </div>
        <button onClick={dismiss} className="text-white/50 hover:text-white" aria-label="Fermer"><X size={16} /></button>
      </div>
    </div>
  );
}
